import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const capabilities = [
    { name: 'CNC Machining', path: '/capabilities/cnc-machining' },
    { name: 'Injection Molding', path: '/capabilities/injection-molding' },
    { name: 'Die Casting', path: '/capabilities/die-casting' },
    { name: 'Sheet Metal', path: '/capabilities/sheet-metal' },
    { name: 'Aluminum Extrusion', path: '/capabilities/aluminum-extrusion' },
    { name: 'Assembly', path: '/capabilities/assembly' }
  ];

  const quickLinks = [
    { name: 'Quality & Process', path: '/quality-process' },
    { name: 'Global Network', path: '/global-network' },
    { name: 'About', path: '/about' },
    { name: 'Careers', path: '/careers' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">All Parts Manufacturing</h3>
            <p className="text-sm text-primary-foreground/80 mb-4">
              Serving Canadian companies with global manufacturing support.
            </p>
            <div className="space-y-2">
              <a href="mailto:rfq@allpartsmanufacturing.com" className="flex items-center space-x-2 text-sm hover:text-accent transition-smooth">
                <Mail className="h-4 w-4" />
                <span>rfq@allpartsmanufacturing.com</span>
              </a>
              <a href="tel:+16048300143" className="flex items-center space-x-2 text-sm hover:text-accent transition-smooth">
                <Phone className="h-4 w-4" />
                <span>+1-604-830-0143</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Capabilities */}
          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Capabilities</h4>
            <ul className="space-y-2">
              {capabilities.map((capability) => (
                <li key={capability.path}>
                  <Link to={capability.path} className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                    {capability.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Network */}
          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Global Network</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/global-network/canada" className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                  Canada
                </Link>
              </li>
              <li>
                <Link to="/global-network/malaysia" className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                  Malaysia
                </Link>
              </li>
              <li>
                <Link to="/global-network/china" className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                  China
                </Link>
              </li>
              <li>
                <Link to="/global-network/mexico" className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                  Mexico
                </Link>
              </li>
              <li>
                <Link to="/global-network/vietnam" className="text-sm text-primary-foreground/80 hover:text-accent transition-smooth">
                  Vietnam
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-primary-foreground/60">
              © {new Date().getFullYear()} All Parts Manufacturing. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-sm text-primary-foreground/60 hover:text-accent transition-smooth">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-primary-foreground/60 hover:text-accent transition-smooth">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
